import React, { useEffect, useState } from 'react';
import { Box, Card, Typography, Rating, Stack, Grow, useMediaQuery } from '@mui/material';
import StarIcon from '@mui/icons-material/Star';
import { useTheme } from '@mui/material/styles';

const reviews = [
  {
    name: 'Sarah T.',
    rating: 5,
    comment: 'The team at Sparkle Clean transformed my kitchen! The countertops are gleaming, and my oven looks brand new. I\'m thrilled with their attention to detail!',
    image: '/images/review-photos/photo1.jpeg',
    date: 'March 2025',
    location: 'Orlando',
  },
  {
    name: 'Michael R.',
    rating: 4.5,
    comment: 'My closet has never been so organized! I am amazed at how well it looks—every shelf is tidy, and my clothes are perfectly folded.',
    image: '/images/review-photos/photo2.jpeg',
    date: 'February 2025',
    location: 'Kissimmee',
  },
  {
    name: 'Emily C.',
    rating: 5,
    comment: 'The bathroom cleaning was phenomenal. The tiles are sparkling, and the grout looks like it was just installed. I\'m so impressed!',
    image: '/images/review-photos/photo3.jpeg',
    date: 'January 2025',
    location: 'Orlando',
  },
  {
    name: 'David P.',
    rating: 5,
    comment: '5 Faries Cleaning made my living room feel like a showroom. The carpets are fluffier, and the furniture looks brand new after their deep clean.',
    image: '/images/review-photos/photo4.jpeg',
    date: 'January 2025',
    location: 'Orlando',
  },
  {
    name: 'Olivia M.',
    rating: 4,
    comment: 'The deep clean of my bedroom was a game-changer. The dust is gone, and my bed looks like it belongs in a hotel. I sleep better now!',
    image: '/images/review-photos/photo5.jpeg',
    date: 'May 2025',
    location: 'Orlando',
  },
  {
    name: 'James L.',
    rating: 4,
    comment: 'I can\'t believe how clean my windows are! They\'re so clear, it\'s like there\'s no glass at all. The whole house feels brighter.',
    image: '/images/review-photos/photo6.jpeg',
    date: 'May 2025',
    location: 'Kissimmee',
  },
  {
    name: 'Ava J.',
    rating: 4,
    comment: 'The team tackled my garage, and it\'s now a functional space! Everything is organized, and the floor is spotless. I\'m beyond happy.',
    image: '/images/review-photos/photo7.jpeg',
    date: 'May 2025',
    location: 'Kissimmee',
  },
  {
    name: 'Liam N.',
    rating: 4,
    comment: 'My dining room chandelier sparkles like never before. The whole room feels elegant now, thanks to their meticulous cleaning.',
    image: '/images/review-photos/photo8.jpeg',
    date: 'May 2025',
    location: 'Orlando',
  },
  {
    name: 'James L.',
    rating: 4,
    comment: 'I can\'t believe how clean my windows are! They\'re so clear, it\'s like there\'s no glass at all. The whole house feels brighter.',
    image: '/images/review-photos/photo10.jpeg',
    date: 'May 2025',
    location: 'Kissimmee',
  },
  {
    name: 'Sophia K.',
    rating: 4,
    comment: 'The pet hair is gone! My floors and furniture are fur-free, and the house smells so fresh. They\'re miracle workers for pet owners.',
    image: '/images/review-photos/photo9.jpeg',
    date: 'May 2025',
    location: 'Kissimmee',
  },
  {
    name: 'Ethan B.',
    rating: 4,
    comment: 'The move-out cleaning was flawless. Every corner of the apartment was spotless, and I got my full deposit back. Highly recommend!',
    image: '/images/review-photos/photo10.jpeg',
    date: 'May 2025',
    location: 'Kissimmee',
  }
];

const CustomerReviews = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [paused, setPaused] = useState(false);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const VISIBLE_COUNT = isMobile ? 1 : 3;
  // Compute the visible set, wrapping around
  const visibleReviews = [];
  for (let i = 0; i < VISIBLE_COUNT; i++) {
    visibleReviews.push(reviews[(currentIndex + i) % reviews.length]);
  }

  useEffect(() => {
    if (paused) return;
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + VISIBLE_COUNT) % reviews.length);
    }, 2000);
    return () => clearInterval(interval);
  }, [paused, VISIBLE_COUNT]);

  return (
    <Box
      sx={{
        py: 2,
        px: { xs: 1, sm: 2 },
        bgcolor: 'background.paper',
        maxWidth: VISIBLE_COUNT === 1 ? 360 : 1200,
        mx: 'auto',
        my: 0,
        borderRadius: 3,
        boxShadow: 3,
        overflow: 'visible',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
      }}
      onMouseEnter={() => setPaused(true)}
      onMouseLeave={() => setPaused(false)}
    >
      <Typography variant="h4" align="center" gutterBottom fontWeight={700} color="primary.main">
        What Our Customers Say
      </Typography>
      <Box sx={{ display: 'flex', flexDirection: 'row', gap: 2, justifyContent: 'center', width: '100%' }}>
        {visibleReviews.map((review, idx) => (
          <Grow in timeout={600} key={review.name + idx}>
            <Card sx={{ p: 2, display: 'flex', flexDirection: 'column', alignItems: 'center', boxShadow: 8, border: '1.5px solid', borderColor: 'gold.main', width: VISIBLE_COUNT === 1 ? '100%' : 340, bgcolor: 'background.paper' }}>
              <Stack direction="column" alignItems="center" spacing={1}>
                <Typography variant="subtitle1" fontWeight={600} color="primary.main">
                  {review.name}{' '}
                  <Typography component="span" variant="subtitle2" sx={{ color: '#6FCF97', fontWeight: 400 }}>({review.location})</Typography>
                </Typography>
                <Rating
                  value={review.rating}
                  precision={0.5}
                  readOnly
                  size="medium"
                  icon={<StarIcon fontSize="inherit" sx={{ color: 'gold.main' }} />}
                  emptyIcon={<StarIcon fontSize="inherit" sx={{ color: 'grey.300' }} />}
                />
                <Typography variant="body2" color="text.secondary" align="center" sx={{ mt: 1 }}>
                  "{review.comment}"
                </Typography>
                <Typography variant="caption" color="text.disabled" sx={{ mt: 1 }}>
                  {review.date}
                </Typography>            
                {review.image && (
                  <Box
                    component="img"
                    src={review.image}
                    alt={`Photo from ${review.name}`}
                    sx={{
                      width: '100%',
                      maxWidth: 280,
                      aspectRatio: '4 / 3',
                      objectFit: 'contain',
                      borderRadius: 2,
                      mt: 2,
                    }}
                  />
                )}
              </Stack>
            </Card>
          </Grow>
        ))}
      </Box>
    </Box>
  );
};

export default CustomerReviews;
